import { PapiTag } from '@wix/da-papi-types';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import EmptyResult from '../../../EmptyResult';
import OrderDropdown from '../../_partials/OrderDropdown';
import BasePageLayout from '../../_partials/BasePageLayout';
import DefaultPageContent from '../../_partials/DefaultPageContent';
import s from './TagPage.scss';

export interface Props {
  tag?: PapiTag;
  hasOrderSubnav?: boolean;
}

const TagPage: React.FC<Props> = ({ tag, hasOrderSubnav }) => {
  const isMobile = useContext(MobileContext);
  const { t } = useTranslation();
  if (!tag) {
    return <EmptyResult />;
  }
  return (
    <BasePageLayout
      title={
        <h1 className={s['title']}>
          {t('tagPage.headline', {
            postProcess: 'reactPostprocessor',
            tag: <span className={s['title-tag']}>{tag.tag}</span>,
          })}
        </h1>
      }
      headerRightSideContent={hasOrderSubnav && !isMobile && <OrderDropdown />}
      withNetworkBar={false}
      withNavigation={false}
      titleClassName={s['title-block']}
      contentClassName={s['content-block']}
    >
      {isMobile && hasOrderSubnav && (
        <div className={s['order-dropdown']}>
          <OrderDropdown />
        </div>
      )}
      <DefaultPageContent />
    </BasePageLayout>
  );
};
TagPage.displayName = 'TagPage';

export default TagPage;
